const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  "WETH.e_WAVAX": "0xfe15c2695f1f920da45c30aae47d11de51007af9"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS["WETH.e_WAVAX"]]: 26
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS["WETH.e_WAVAX"]]: 1
};

module.exports = {
  ADDRESS: "0xd6a4f121ca35509af06a0be99093d08462f53052",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
